import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import FlexBetweenRow from './FlexBetweenRow'
import HoverableTooltipRecommendation from './HoverableTooltipRecommendation'

interface Props {
  teamOverlaps?: number
  teamOverlapsNames?: string[] | null
  totalOverlaps?: number
  totalOverlapsNames?: string[] | null
  onlyShifts?: boolean
  availableDays?: number
  mode?: 'inline' | 'availableDays'
  labelOverride?: string
  shiftsLabelOverride?: string
}

const Separator = () => (
  <Box paddingY="s12">
    <div style={{ width: '100%', height: 1, background: '#888' }} />
  </Box>
)

function NamesList({ names }: { names: string[] }) {
  const maxVisible = 5
  const visibleNames = names.slice(0, maxVisible)
  const extraCount = names.length - maxVisible
  return (
    <div>
      <Text.Normal color="grey000White" size="200">
        {visibleNames.join(', ')}
        {extraCount > 0 && `, +${extraCount}`}
      </Text.Normal>
    </div>
  )
}
const WrapperApproveTooltip = ({
  teamOverlaps = 0,
  teamOverlapsNames = null,
  totalOverlaps = 0,
  totalOverlapsNames = null,
  onlyShifts = false,
  availableDays,
  mode = 'inline',
  labelOverride,
  shiftsLabelOverride,
}: Props) => {
  const directReports = 0
  if (mode === 'inline') {
    if (onlyShifts) {
      return (
        <HoverableTooltipRecommendation
          label={labelOverride ?? ''}
          title={i18n.t('time_off.approval_recommendation.scheduled_work_tooltip_title')}
          count={0}
          labelDotted
          showCount={false}
          details={
            <>
              <Box paddingY="s4" />
              <FlexBetweenRow>
                <Text.Normal color="grey000White" size="200">
                  {shiftsLabelOverride}
                </Text.Normal>
                <Text.Normal color="grey000White" size="200">
                  {i18n.tp('time_off.approval_recommendation.day_shifts', { count: 0 })}
                </Text.Normal>
              </FlexBetweenRow>
            </>
          }
        />
      )
    }

    // Tooltip overlaps
    return (
      <HoverableTooltipRecommendation
        label={labelOverride ?? ''}
        title={i18n.t('time_off.approval_recommendation.overlaps_tooltip_title')}
        count={teamOverlaps + totalOverlaps}
        labelDotted
        showCount={false}
        details={
          <>
            <Box paddingY="s4" />
            <FlexBetweenRow>
              <Text.Normal color="grey000White" size="200" weight="semibold">
                {i18n.t('time_off.approval_recommendation.overlaps_tooltip_subtitle')}
              </Text.Normal>
              <Text.Normal color="grey000White" size="200" weight="semibold">
                {directReports}
              </Text.Normal>
            </FlexBetweenRow>
            {totalOverlapsNames !== null && (
              <>
                <Separator />
                <FlexBetweenRow>
                  <Text.Normal color="grey000White" size="200" weight="semibold">
                    {i18n.t('time_off.approval_recommendation.overlaps_total_reports')}
                  </Text.Normal>
                  <Text.Normal color="grey000White" size="200" weight="semibold">
                    {totalOverlaps}
                  </Text.Normal>
                </FlexBetweenRow>
                {totalOverlapsNames && totalOverlapsNames.length > 0 && (
                  <NamesList names={totalOverlapsNames} />
                )}
              </>
            )}
            {teamOverlapsNames !== null && (
              <>
                <Separator />
                <FlexBetweenRow>
                  <Text.Normal color="grey000White" size="200" weight="semibold">
                    {i18n.t('time_off.approval_recommendation.overlaps_team_members')}
                  </Text.Normal>
                  <Text.Normal color="grey000White" size="200" weight="semibold">
                    {teamOverlaps}
                  </Text.Normal>
                </FlexBetweenRow>
                {teamOverlapsNames && teamOverlapsNames.length > 0 && (
                  <NamesList names={teamOverlapsNames} />
                )}
              </>
            )}
          </>
        }
      />
    )
  }

  if (mode === 'availableDays' && typeof availableDays === 'number') {
    // Tooltip available days
    let formattedDays: string
    if (Number.isInteger(availableDays)) {
      formattedDays = `${availableDays}`
    } else if (availableDays % 1 === 0) {
      formattedDays = `${availableDays.toFixed(0)}`
    } else {
      formattedDays = `${availableDays}`
    }
    const days = Math.abs(Number(formattedDays))
    const daysLabel = i18n.tp('time_off.approval_recommendation.day_shifts', { count: days })

    return (
      <HoverableTooltipRecommendation
        label={i18n.t('time_off.approval_recommendation.available_days_tooltip')}
        title={labelOverride ?? ''}
        count={availableDays}
        labelDotted
        showCount={false}
        details={
          <>
            <Box paddingY="s4" />
            <FlexBetweenRow>
              <Text.Normal color="grey000White" size="200" weight="semibold">
                {i18n.t('time_off.approval_recommendation.holidays')}
              </Text.Normal>
              <Text.Normal color="grey000White" size="200" weight="semibold">
                {daysLabel}
              </Text.Normal>
            </FlexBetweenRow>
          </>
        }
      />
    )
  }
  return null
}

export default WrapperApproveTooltip
